import React from 'react';

interface Props {
  weeks: number[];
  selected: number;
  onChange: (week: number) => void;
  stageColors?: Record<number, string>;
  stageLabels?: Record<number, string>;
}

export const WeekSelector: React.FC<Props> = ({ weeks, selected, onChange, stageColors, stageLabels }) => (
  <div className="flex flex-wrap gap-2">
    {weeks.map(w => {
      const active = w === selected;
      const color = stageColors?.[w];
      return (
        <button
          key={w}
          onClick={() => onChange(w)}
          className={`relative flex flex-col items-center justify-center w-12 h-12 rounded-xl text-xs font-bold transition-all border-2 ${
            active
              ? 'text-white shadow-md border-transparent'
              : 'bg-white text-slate-600 border-[#e2e8f0] hover:border-primary hover:text-primary'
          }`}
          style={active && color ? { backgroundColor: color, borderColor: color } : active ? { backgroundColor: '#00c7c4', borderColor: '#00c7c4' } : {}}
        >
          <span className="text-[10px] font-semibold opacity-70">WK</span>
          <span className="leading-none">{w}</span>
          {stageLabels?.[w] && (
            <span className={`text-[9px] mt-0.5 ${active ? 'opacity-80' : 'text-slate-400'}`}>{stageLabels[w]}</span>
          )}
        </button>
      );
    })}
  </div>
);
